import request from "@/utils/request";
export function footer(data) {
    return request({
        url: '/api/portal/v1/portal/selectInfo',
        method: 'post',
        data
    })
}
